export default __webpack_public_path__ + "static/media/Ballroll_00039.ccb8dee6.png";